import React from "react";
import { SealogEventValueDropdown } from "../sealogEvent/sealogEventValueDropdown";
import { SealogEventFreeTextDropdown } from "../sealogEvent/sealogEventFreeTextDropdown";
import { SealogEventOptionNameDropdown } from "../sealogEvent/sealogEventOptionNameDropdown";
import { SealogEventOptionValueDropdown } from "../sealogEvent/sealogEventOptionValueDropdown";
import { FaChevronUp, FaChevronDown } from "react-icons/fa6";

const SealogEventFiltersGroup = ({
  rawValues,
  handleSealogEventValueSelection,
  handleSealogEventFreeTextSelection,
  handleSealogEventOptionNameSelection,
  handleSealogEventOptionValueSelection,
  areSealogFiltersToggled,
  toggleSealogFilters,
  showEventValueFilter = true,
  showEventFreeTextFilter = true,
  showEventOptionNameFilter = true,
  showEventOptionValueFilter = true,
}: {
  rawValues: any;
  handleSealogEventValueSelection: (option: any) => void;
  handleSealogEventFreeTextSelection: (option: any) => void;
  handleSealogEventOptionNameSelection: (option: any) => void;
  handleSealogEventOptionValueSelection: (option: any) => void;
  areSealogFiltersToggled: boolean;
  toggleSealogFilters: () => void;
  showEventValueFilter?: boolean;
  showEventFreeTextFilter?: boolean;
  showEventOptionNameFilter?: boolean;
  showEventOptionValueFilter?: boolean;
}) => {
  const hasAnyFilter =
    showEventValueFilter ||
    showEventFreeTextFilter ||
    showEventOptionNameFilter ||
    showEventOptionValueFilter;

  if (!hasAnyFilter) return null;

  return (
    <div className="col-span-10 col-start-2">
      <div
        className="flex w-full cursor-pointer items-center justify-between"
        onClick={toggleSealogFilters}
      >
        <p className="text-lg text-blue-200">Sealog Event Filters</p>
        {areSealogFiltersToggled ? (
          <FaChevronUp size={16} />
        ) : (
          <FaChevronDown size={16} />
        )}
      </div>
      <div
        style={{
          maxHeight: areSealogFiltersToggled ? "16rem" : "0",
          transition: "max-height 0.2s ease-in-out",
        }}
        className={`my-2 flex w-full ${
          areSealogFiltersToggled ? "" : "overflow-hidden"
        }`}
      >
        <div className="w-full">
          <div className="relative z-20 mb-2 mt-1 flex flex-wrap gap-4">
            {showEventValueFilter && (
              <SealogEventValueDropdown
                dropdownProps={{
                  selections: rawValues.sealogEventValues,
                  onOptionToggle: handleSealogEventValueSelection,
                  className: "w-[11rem] shrink-0",
                }}
                apiOptions={{
                  eventFreeTexts: rawValues.sealogEventFreeTexts,
                  eventOptionNames: rawValues.sealogEventOptionNames,
                  eventOptionValues: rawValues.sealogEventOptionValues,
                  hasDataAsset: true,
                }}
              />
            )}
            {showEventFreeTextFilter && (
              <SealogEventFreeTextDropdown
                dropdownProps={{
                  selections: rawValues.sealogEventFreeTexts,
                  onOptionToggle: handleSealogEventFreeTextSelection,
                  className: "w-[12rem] shrink-0",
                }}
                apiOptions={{
                  eventValue: rawValues.sealogEventValues,
                  eventOptionNames: rawValues.sealogEventOptionNames,
                  eventOptionValues: rawValues.sealogEventOptionValues,
                  hasDataAsset: true,
                }}
              />
            )}
            {showEventOptionNameFilter && (
              <SealogEventOptionNameDropdown
                dropdownProps={{
                  selections: rawValues.sealogEventOptionNames,
                  onOptionToggle: handleSealogEventOptionNameSelection,
                  className: "w-[13rem] shrink-0",
                }}
                apiOptions={{
                  eventValue: rawValues.sealogEventValues,
                  eventFreeTexts: rawValues.sealogEventFreeTexts,
                  eventOptionValues: rawValues.sealogEventOptionValues,
                  hasDataAsset: true,
                }}
              />
            )}
            {showEventOptionValueFilter && (
              <SealogEventOptionValueDropdown
                dropdownProps={{
                  selections: rawValues.sealogEventOptionValues,
                  onOptionToggle: handleSealogEventOptionValueSelection,
                  className: "w-[15rem] shrink-0",
                }}
                apiOptions={{
                  eventValue: rawValues.sealogEventValues,
                  eventFreeTexts: rawValues.sealogEventFreeTexts,
                  eventOptionNames: rawValues.sealogEventOptionNames,
                  hasDataAsset: true,
                }}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SealogEventFiltersGroup;
